import Vue from "vue";
import VueRouter from "vue-router";

import store from "../store";

import RegistrationLocation from "../components/RegistrationLocation";

import AgeVerification from "../components/AgeVerification";
import ChooseProfile from "../components/ChooseProfile";

import BasicProfile from "../components/BasicProfile";

import LoginForm from "../components/LoginForm";
import ChangeEmail from "../components/ChangeEmail";
import ChangePassword from "../components/ChangePassword";

Vue.use(VueRouter);

const onLoginStep = () => {
  return !!store.getters.readyForAccount;
};

const onChooseProfileStep = () => {
  return !!(
    store.state.registration.termsAgreed &&
    store.getters.isAgeSet &&
    !store.state.registration.profileChoice
  );
};

const onBasicProfileStep = () => {
  return !!(
    store.state.registration.termsAgreed &&
    store.getters.isAgeSet &&
    store.state.registration.profileChoice &&
    store.getters.isLocationSet
  );
};

const onLocationStep = () => {
  return !!(
    store.state.registration.termsAgreed &&
    store.getters.isAgeSet &&
    store.state.registration.profileChoice
  );
};

const onAgeStep = () => {
  return !!store.state.registration.termsAgreed;
};

const getCurrentStep = () => {
  if (onLoginStep()) {
    return "login";
  } else if (onBasicProfileStep()) {
    return "basic-profile";
  } else if (onChooseProfileStep()) {
    return "choose-profile";
  } else if (onAgeStep()) {
    return "age";
  } else if (onLocationStep()) {
    return "location";
  }
};

export const routes = [
  {
    path: "/",
    beforeEnter: (_to, _from, next) => {
      next({ name: getCurrentStep() });
    },
  },
  {
    path: "/age",
    name: "age",
    component: AgeVerification,
    meta: {
      browserTitle: "Step 3: Age",
    },
  },
  {
    path: "/region",
    name: "location",
    component: RegistrationLocation,
    meta: {
      browserTitle: "Step 2: Region",
    },
  },
  {
    path: "/choose-profile",
    name: "choose-profile",
    component: ChooseProfile,
    meta: {
      browserTitle: "Step 4: Choose your profile",
    },
  },
  {
    path: "/basic-profile",
    name: "basic-profile",
    component: BasicProfile,
    meta: {
      browserTitle: "Step 5: Basic Profile",
    },
  },
  {
    path: "/signin",
    name: "login",
    component: LoginForm,
    meta: {
      browserTitle: "Final step: Sign In",
    },
    beforeEnter: (_to, _from, next) => {
      if (store.state.registration.isLocked) {
        next({ name: "basic-profile" });
      } else {
        next();
      }
    },
  },
  {
    path: "/change-email",
    name: "change-email",
    component: ChangeEmail,
    meta: {
      browserTitle: "Change your Email",
    },
  },
  {
    path: "/change-password",
    name: "change-password",
    component: ChangePassword,
    meta: {
      browserTitle: "Change your Password",
    },
  },
];

export const router = new VueRouter({
  routes,
});

router.afterEach((to, _from) => {
  if (window && window.document && to.meta.browserTitle)
    window.document.title = to.meta.browserTitle + " • Technovation";
});

export default router;
